import InfiniteScroll from "react-infinite-scroll-component";
import { Check, LoaderCircle } from "lucide-react";
import SkeletonMusicLibrariesTable from "pages/account-detail/music-libraries/skeleton/SkeletonMusicLibrariesTable";
import { useDispatch } from "react-redux";
import { setIndexProductservicse } from "store/header";
import UploadProductServicePhoto from "components/app/upload-profile/UploadProductServicePhoto";
import { iconNoProduct } from "assets";

const ProductServiceTable = ({
  listRef,
  productDatas,
  productLoading,
  loadingFetchDataProducts,
  fetchMoreUserShopProduct,
  setDefaultDataProduct,
  getShopProductDetail,
  setOpenPopoverIndex,
  setId,
  selectProducts,
  setSelectedProductIds,
  selectedProductIds,
  setProductDatas,
  handleClickUrl,
}: any) => {
  const dispatch = useDispatch();
  return (
    <InfiniteScroll
      dataLength={productDatas?.data?.length || 0}
      next={() =>
        fetchMoreUserShopProduct({
          next: productLoading?.nextPageUrl,
        })
      }
      scrollThreshold="90%"
      hasMore={!!productLoading?.nextPageUrl}
      scrollableTarget="scrollableDiv"
      loader={
        <div className="absolute bottom-2 left-0 w-full flex justify-center mt-5">
          <LoaderCircle size={30} className="animate-spin text-yellow-400" />
        </div>
      }
    >
      {loadingFetchDataProducts ? (
        <SkeletonMusicLibrariesTable />
      ) : (
        // <div className="overflow-x-auto lg:overflow-visible w-[700px]">
        <table className="min-w-full border-collapse mb-20 rounded-md ">
          <thead className="sticky top-0 left-0 text-xs text-gray-700  bg-gray-300 dark:bg-[#2c3a52] dark:text-gray-400">
            <tr className="border-none  text-[15px] text-start">
              <th className="py-5 px-4 first:rounded-tl-md last:rounded-tr-md ">Image</th>
              <th className=" px-4 text-start ">Product Info.</th>
              <th className=" px-4 text-start">Group</th>
              <th className=" px-4 text-start">Code</th>
              <th className=" px-4 text-start">Specification</th>
              <th className=" px-4 text-start">Selling</th>
              <th className=" px-4 text-start">Option</th>
              <th className=" px-4 text-start">Marketplaces</th>
              {productDatas?.data?.some((item: any) => item.is_deleted === 0) && <th className="px-4 rounded-tr-md text-start">Status</th>}
            </tr>
          </thead>
          <tbody ref={listRef}>
            {productDatas?.data?.map((item: any, index: number) => (
              <tr
                onClick={() => {
                  if (selectProducts) {
                    setSelectedProductIds((prev: any) => (prev.includes(item.id) ? prev.filter((id: number) => id !== item.id) : [...prev, item.id]));
                    return;
                  } else {
                    if (item.is_deleted === 0) {
                      dispatch(setIndexProductservicse(item.id));
                      setOpenPopoverIndex(1);
                      getShopProductDetail(item?.product_id, item?.product_group_id);
                      setDefaultDataProduct(true);
                      setId(item.product_group_id);
                      handleClickUrl(item?.product_id, "product_id");
                    }
                  }
                }}
                key={index}
                className={`group text-center cursor-pointer ${index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b] " : "bg-gray-200 dark:bg-[#2c3a52] "} hover:bg-gray-300`}
              >
                <td className="relative w-[100px] h-[100px]">
                  <div
                    className={`${
                      selectedProductIds.includes(item.id) ? "bg-white" : ""
                    } w-4 h-4 rounded-full flex items-center justify-center absolute left-[6px] top-[6px] z-50 text-xl  ${!selectProducts ? " hidden" : " block"}`}
                  >
                    {selectedProductIds.includes(item.id) ? (
                      <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                    ) : (
                      <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full"></i>
                    )}
                  </div>
                  {selectProducts === true && <div className="absolute inset-0 mx-auto top-[32px] z-50  w-8 h-8  text-white  rounded-full p-1"></div>}
                  {item.is_deleted === 0 ? (
                    <button
                      onClick={(event) => {
                        event.stopPropagation();
                      }}
                      className=" opacity-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300 absolute z-50 inset-0 mx-auto top-[40%] cursor-pointer  w-8 h-8  text-white bg-black/50 rounded-full p-1"
                    >
                      <UploadProductServicePhoto
                        editItemByCategories={item}
                        onUploadSuccess={({ res, name }) => {
                          setProductDatas((prevItemGroups: any) => {
                            const updatedData = (prevItemGroups.data || []).map((item: any) => (item.id === res.id ? { ...item, ...res } : item));
                            const exists = updatedData.some((item: any) => item.id === res.id);
                            if (!exists) {
                              updatedData.push(res);
                            }
                            return {
                              ...prevItemGroups,
                              data: updatedData,
                            };
                          });
                        }}
                      />
                    </button>
                  ) : (
                    <button
                      onClick={(event) => {
                        event.stopPropagation();
                      }}
                      className=" font-semibold z-50 absolute flex items-center justify-center text-white shadow-md shadow-red-500 inset-0 mx-auto top-[40%] cursor-pointer w-[80px] h-8 bg-black/50 rounded-full p-1"
                    >
                      Deleted
                    </button>
                  )}

                  <img className={`w-full h-[100px] z-1 mx-auto relative ${item.is_deleted === 1 && "opacity-50"} `} src={!item.picture ? iconNoProduct : item.picture} alt="" />
                </td>
                <td className="py-2 px-4 text-md  text-left align-top w-[120px] ">
                  {/* <p className="text-lg font-semibold">{item.local_description}dd</p> */}
                  <p
                    className="text-md text-muted-foreground line-clamp-3"
                    dangerouslySetInnerHTML={{
                      __html: item.local_description?.replace(/\n/g, "<br />"),
                    }}
                  ></p>
                  <p className="text-md text-muted-foreground">{item?.flag}</p>
                </td>
                <td className="py-2 px-4 text-left align-top  ">
                  <p className="text-md font-semibold">{item?.product_group?.local_description}</p>
                  <p className="text-md text-muted-foreground">{item.product_type}</p>
                </td>
                <td className="py-2 px-4 text-left align-top ">
                  <p className="text-md font-semibold">{item?.product_no}</p>
                  <p className="text-md text-muted-foreground">{item.alias_no}</p>
                  <p className="text-md text-muted-foreground">{item.production_lead_time}</p>
                </td>

                <td className="py-2 px-4 text-left align-top ">
                  <p className="text-md font-semibold">
                    <span
                      className="text-sm text-gray-500 line-clamp-4"
                      dangerouslySetInnerHTML={{
                        __html: item?.specification?.replace(/\n/g, "<br />"),
                      }}
                    ></span>
                  </p>
                </td>
                <td className="py-2 px-4  text-left align-top">
                  <p className="text-[17px]  font-bold">{item?.unit_price}</p>
                  <p className="text-md text-muted-foreground">
                    {item.min_order} {item.min_order && "MOQ"}
                  </p>
                  <p className="text-md text-muted-foreground">{item.unit_of_measure}</p>
                </td>
                <td className="py-2 px-4  text-left align-top ">
                  <p className="text-md font-semibold flex items-center gap-2">
                    {item?.use_sugar === "Yes" && "Sugar"} {item?.use_sugar === "Yes" && <Check />}
                  </p>
                  <p className="text-md text-muted-foreground flex items-center gap-2">
                    {item?.use_size === "Yes" && "Size"} {item?.use_size === "Yes" && <Check />}
                  </p>
                  <p className="text-md text-muted-foreground flex items-center gap-2">
                    {item?.use_modifier === "Yes" && "Modifier"} {item?.use_modifier === "Yes" && <Check />}
                  </p>
                </td>
                <td className="py-2 px-4 text-left align-top ">
                  <div className={` ${item?.status === "Unpublished" ? "bg-red-500" : "bg-blue-500"}  text-white px-3 py-1 rounded-md mt-0 text-center inline-block`}>
                    <span className=" text-sm font-bold ">
                      {" "}
                      {item.status === "Unpublished" && item.is_deleted !== 1 ? (
                        <p className="text-md font-semibold">{item?.status}</p>
                      ) : (
                        <p className="text-md font-semibold">{item?.status}</p>
                      )}
                    </span>
                  </div>
                </td>
                <td className="py-2 px-4 text-left align-top text-md font-semibold">{item.inactived}</td>
              </tr>
            ))}
            {!productDatas?.next_page_url ? (
              <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
                <b>Nothing more to load!</b>
              </p>
            ) : (
              ""
            )}
          </tbody>
        </table>
        // </div>
      )}
    </InfiniteScroll>
  );
};

export default ProductServiceTable;
